import {Component, Inject, OnInit} from '@angular/core';
import {MatDialog, MatDialogRef} from '@angular/material/dialog';
import {MAT_DIALOG_DATA, MatSnackBar} from '@angular/material';
import {ConfService} from '../../conf.service';
import {COMMA, ENTER} from '@angular/cdk/keycodes';
import {MatChipInputEvent} from '@angular/material/chips';
import {LeftpanelComponent} from '../../leftpanel/leftpanel.component';
import {KongService} from '../../kong.service';
import {environment} from '../../../environments/environment';
import {ShowCredentialsComponent} from '../../settings/connectors/connectors.component';
import * as CryptoJS from 'crypto-js';


export interface DialogData {
    Topic: any;
    type: any;
    attributes: [
        {
            name: any,
            description: any,
            option: any
        }
    ];
    id: any;
    partnerName: any;
}


@Component({
    selector: 'app-create-credential-dialog',
    templateUrl: './create-credential-dialog.component.html',
    styleUrls: ['./create-credential-dialog.component.scss']
})
export class CreateCredentialDialogComponent implements OnInit {

    formResponse = {};
    jwtAlgorithms = ['HS256', 'RS256'];
    selectedJWTAlgo = 'HS256';
    visible = true;
    selectable = true;
    removable = true;
    addOnBlur = true;
    readonly separatorKeysCodes: number[] = [ENTER, COMMA];
    chipItems = [];
    chipList: any;
    accountName: any;

    constructor(public dialogRef: MatDialogRef<CreateCredentialDialogComponent>, public confPost: ConfService, public dialog: MatDialog,
                @Inject(MAT_DIALOG_DATA) public data: DialogData, private kongService: KongService, private _snackBar: MatSnackBar, public platform: LeftpanelComponent) {
    }

    ngOnInit() {
        const temp = localStorage.getItem('partner').split('-');
        this.accountName = temp[temp.length - 1];
        for (const attribute of this.data.attributes) {
            this.formResponse[attribute['name']] = '';
        }
    }

    postKongDetails(id, payload, type) {
        this.kongService.postKongGatewayAPIkeyDetails(id, payload, type).subscribe(response => {
            if (response) {
                this.dialogRef.close(type);
                this.platform.openSnackBar('New ' + type + ' created', 'Success', {
                    duration: 3000,
                    verticalPosition: 'top',
                    horizontalPosition: 'center'
                });
            }
        }, error => {
            this.platform.openSnackBar('Error while creating the credential: ' + error['error']['name'], 'Error', {
                duration: 3000,
                verticalPosition: 'top',
                horizontalPosition: 'center'
            });
        });
    }

    createCredential(type) {

        switch (type) {
            case 'key-auth':
                for (const attr of this.data.attributes) {
                    if (this.formResponse[attr['name']] === '') {
                        delete this.formResponse[attr['name']];
                    }
                }
                this.postKongDetails(this.data['id'], this.formResponse, type);
                break;
            case 'jwt':
                for (const attr of this.data.attributes) {
                    if (this.formResponse[attr['name']] === '') {
                        delete this.formResponse[attr['name']];

                    }
                }
                this.formResponse['algorithm'] = this.selectedJWTAlgo;
                this.postKongDetails(this.data['id'], this.formResponse, type);
                break;
            case 'oauth2':
                for (const attr of this.data.attributes) {
                    if (this.formResponse[attr['name']] === '') {
                        delete this.formResponse[attr['name']];
                    }
                }
                this.formResponse['redirect_uris'] = this.chipItems;
                this.postKongDetails(this.data['id'], this.formResponse, type);
                break;
            case 'basic-auth':
                for (const attr of this.data.attributes) {
                    if (this.formResponse[attr['name']] === '') {
                        delete this.formResponse[attr['name']];
                    }
                }
                this.postKongDetails(this.data['id'], this.formResponse, type);
                break;
            case 'hmac-auth':
                for (const attr of this.data.attributes) {
                    if (this.formResponse[attr['name']] === '') {
                        delete this.formResponse[attr['name']];
                    }
                }
                this.postKongDetails(this.data['id'], this.formResponse, type);
                break;
            case 'acls':
                // this.formResponse['group'] = this.accountName + ':' + this.formResponse['Group name'];
                this.formResponse['group'] = this.formResponse['Group name'];
                delete this.formResponse['Group name'];
                const groupSplit = this.formResponse['group'].split(':');
                // if (groupSplit.length > 1) {
                    const split = groupSplit[0].split('-');
                    if (split.length === 1) {
                        if (split[0] !== this.accountName) {
                            this.confPost.getPartnerByName('admin-' + split[0]).subscribe(response => {
                                const associateDialogRef = this.dialog.open(AssociateWithGroupComponent, {
                                    width: '60%'
                                });
                                associateDialogRef.afterClosed().subscribe(decision => {
                                    if (decision && decision === 'yes') {
                                        const dialogRef = this.dialog.open(VerifyCredentialsComponent, {
                                            data: {
                                                partnerData: response,
                                                partnerShortCode: split[0]
                                            },
                                            width: '50%'
                                        });
                                        dialogRef.afterClosed().subscribe(resp1 => {
                                            if (resp1 && resp1 === 'valid') {
                                                this.postKongDetails(this.data['id'], this.formResponse, type);
                                            }
                                        });
                                    } else if (decision && decision === 'create') {
                                        this.formResponse['group'] = this.accountName + ':' + this.formResponse['group'];
                                        this.postKongDetails(this.data['id'], this.formResponse, type);
                                    }
                                });
                            }, error => {
                                if (error.status === 404) {
                                    this.formResponse['group'] = this.accountName + ':' + this.formResponse['group'];
                                    this.postKongDetails(this.data['id'], this.formResponse, type);
                                } else {
                                    this.platform.openSnackBar('Error while creating the group. Please try again after sometime.', 'Error', {
                                        duration: 3000,
                                        verticalPosition: 'top',
                                        horizontalPosition: 'center'
                                    });
                                    this.dialogRef.close('acls');
                                }
                            });
                        } else {
                            const associateDialogRef = this.dialog.open(AssociateWithGroupComponent, {
                                width: '60%'
                            });
                            associateDialogRef.afterClosed().subscribe(decision => {
                                if (decision && decision === 'yes') {
                                    this.postKongDetails(this.data['id'], this.formResponse, type);
                                } else if (decision && decision === 'create') {
                                    this.formResponse['group'] = this.accountName + ':' + this.formResponse['group'];
                                    this.postKongDetails(this.data['id'], this.formResponse, type);
                                }
                            });
                        }
                    } else {
                        this.formResponse['group'] = this.accountName + ':' + this.formResponse['group'];
                        this.postKongDetails(this.data['id'], this.formResponse, type);
                    }
                // } else {
                //     this.formResponse['group'] = this.accountName + ':' + this.formResponse['group'];
                //     this.postKongDetails(this.data['id'], this.formResponse, type);
                // }


                // const partnerSplit = localStorage.getItem('partner').split('-');
                // if (this.formResponse['group'].includes('-') || partnerSplit[partnerSplit.length - 1] === this.formResponse['group']) {
                //     this.postKongDetails(this.data['id'], this.formResponse, type);
                // } else {
                //     this.confPost.getPartnerByName(this.formResponse['group']).subscribe(response => {
                //         const dialogRef = this.dialog.open(VerifyCredentialsComponent, {
                //             data: {
                //                 partnerData: response,
                //                 partnerShortCode: this.formResponse['group']
                //             },
                //             width: '50%'
                //         });
                //         dialogRef.afterClosed().subscribe(resp1 => {
                //             if (resp1 && resp1 === 'valid') {
                //                 this.postKongDetails(this.data['id'], this.formResponse, type);
                //             }
                //         });
                //     }, error => {
                //         if (error.status === 404) {
                //             this.confPost.getPartnerByName('admin-' + this.formResponse['group']).subscribe(resp => {
                //                 const dialogRef = this.dialog.open(VerifyCredentialsComponent, {
                //                     data: {
                //                         partnerData: resp,
                //                         partnerShortCode: 'admin-' + this.formResponse['group']
                //                     },
                //                     width: '50%'
                //                 });
                //
                //                 dialogRef.afterClosed().subscribe(resp1 => {
                //                     if (resp1 && resp1 === 'valid') {
                //                         this.postKongDetails(this.data['id'], this.formResponse, type);
                //                     }
                //                 });
                //             }, error1 => {
                //                 if (error1['status'] === 404) {
                //                     this.postKongDetails(this.data['id'], this.formResponse, type);
                //                 }
                //             });
                //         } else {
                //             this.platform.openSnackBar('Error while creating the group. Please try again after sometime.', 'Error', {
                //                 duration: 3000,
                //                 verticalPosition: 'top',
                //                 horizontalPosition: 'center'
                //             });
                //             this.dialogRef.close('acls');
                //         }
                //     });
                // }
                break;
            case 'consumer':
                if (this.formResponse['username'] && this.formResponse['username'] !== undefined) {
                    this.formResponse['username']=this.formResponse['username'].trim();
                    for (const attr of this.data.attributes) {
                        if (this.formResponse[attr['name']] === '') {
                            delete this.formResponse[attr['name']];
                        }
                    }
                    const temp = [this.accountName];
                    this.formResponse['custom_id'] = this.formResponse['username'];
                    this.formResponse['tags'] = temp.concat(this.chipItems);
                    this.kongService.createConsumerToKong(this.formResponse).subscribe(response => {
                            if (response) {
                                this.postKongDetails(response['id'], {}, 'key-auth');
                                this.dialogRef.close('consumers');
                                this.platform.openSnackBar('Consumer created', 'Success', {
                                    duration: 3000,
                                    verticalPosition: 'top',
                                    horizontalPosition: 'center'
                                });
                            }
                        }, error => {
                            this.platform.openSnackBar('Error while creating the consumer: ' + error['error']['name'], 'Error', {
                                duration: 3000,
                                verticalPosition: 'top',
                                horizontalPosition: 'center'
                            });
                        }
                    );
                } else {
                    this.platform.openSnackBar('Please enter valid credential ', 'Error', {
                        duration: 3000,
                        verticalPosition: 'top',
                        horizontalPosition: 'center'
                    });
                }
                break;
        }

    }

    add(event: MatChipInputEvent): void {
        const input = event.input;
        const value = event.value;

        // Add our fruit
        if ((value || '').trim()) {
            this.chipItems.push(value.trim());
        }

        // Reset the input value
        if (input) {
            input.value = '';
        }


    }

    remove(uri): void {
        const index = this.chipItems.indexOf(uri);

        if (index >= 0) {
            this.chipItems.splice(index, 1);
        }
    }

    selectedJwtAlgorithm(event) {
        this.formResponse['algorithm'] = this.selectedJWTAlgo;
    }

    closeDialog() {
        this.dialogRef.close('');
    }


}

@Component({
    selector: 'verify-credentials',
    templateUrl: 'verify-credentials.component.html',
    styleUrls: ['verify-credentials.component.css']
})
export class VerifyCredentialsComponent implements OnInit {

    targetEmail: any;
    password: any;
    connectorName: any;
    domainPartner: string;
    loaderflag = false;

    constructor(
        public platform: LeftpanelComponent,
        public dialogRef: MatDialogRef<VerifyCredentialsComponent>,
        private confPost: ConfService,
        private dialog: MatDialog,
        @Inject(MAT_DIALOG_DATA) public data: any) {
    }

    ngOnInit() {
        this.domainPartner = localStorage.getItem('partner');
    }

    close() {
        this.dialogRef.close();
    }

    encrypt(salt, iv, passPhrase, plainText, keySize, iterationCount) {
        const key = CryptoJS.PBKDF2(passPhrase, CryptoJS.enc.Hex.parse(salt), {keySize: keySize, iterations: iterationCount});
        const encrypted = CryptoJS.AES.encrypt(
            plainText,
            key,
            {iv: CryptoJS.enc.Hex.parse(iv)});
        return encrypted.ciphertext.toString(CryptoJS.enc.Base64);
    }


    verifyPassword() {
        if (this.password && this.password !== '') {
            this.loaderflag = true;
            const iterationCount = 1000;
            let keySize = 128;
            keySize = keySize / 32;
            const passphrase = environment.cipheringPhrase;

            const iv = CryptoJS.lib.WordArray.random(128 / 8).toString(CryptoJS.enc.Hex);
            const salt = CryptoJS.lib.WordArray.random(128 / 8).toString(CryptoJS.enc.Hex);
            const cipherText = this.encrypt(salt, iv, passphrase, this.password, keySize, iterationCount);
            const loginPayload = {
                emailId: this.data['partnerData']['primary_email'],
                environment: 'admin-' + this.data['partnerShortCode'],
                password: cipherText,
                shash: salt,
                ralam: iv
            };
            this.confPost.validateLogin(loginPayload).subscribe(data => {
                if (data.status === 200) {
                    if (data.body != null) {
                        this.dialogRef.close('valid');
                    } else {
                        alert('Incorrect Password');
                        this.loaderflag = false;
                    }
                } else {
                    this.loaderflag = false;
                }
            }, error => {
                if (error.status === 401) {
                    this.platform.openSnackBar('Please enter a valid password', 'Error', {
                        duration: 3000,
                        verticalPosition: 'top',
                        horizontalPosition: 'center'
                    });
                } else {
                    this.platform.openSnackBar(error.error ? error.error : 'Please enter a valid password', 'Error', {
                        duration: 3000,
                        verticalPosition: 'top',
                        horizontalPosition: 'center'
                    });
                }
                this.loaderflag = false;
            });
        } else {
            this.platform.openSnackBar('Please enter password', 'Error', {
                duration: 3000,
                verticalPosition: 'top',
                horizontalPosition: 'center'
            });
        }
    }

}

@Component({
    selector: 'associate-with-group',
    templateUrl: 'associate-with-group.component.html',
    styleUrls: ['associate-with-group.component.css']
})
export class AssociateWithGroupComponent implements OnInit {

    constructor(
        public platform: LeftpanelComponent,
        public dialogRef: MatDialogRef<VerifyCredentialsComponent>,
        private confPost: ConfService,
        private dialog: MatDialog,
        @Inject(MAT_DIALOG_DATA) public data: any) {
    }

    ngOnInit() {
    }

    close() {
        this.dialogRef.close();
    }

    associate(decision) {
        this.dialogRef.close(decision);
    }


}
